<template>
  <svg :class="classes" viewBox="0 0 1628.2 404.72">
    <defs>
      <linearGradient
        id="linear-gradient-white"
        x1="232.28"
        y1="284.56"
        x2="232.28"
        y2="-146.41"
        gradientTransform="translate(285.05 -163.89) rotate(90)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#fff" stop-opacity="0" />
        <stop offset=".15" stop-color="#fff" />
        <stop offset=".85" stop-color="#fff" />
        <stop offset="1" stop-color="#fff" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-blue"
        x1="242.37"
        y1="304.43"
        x2="242.37"
        y2="-153.24"
        gradientTransform="translate(304.94 -170.72) rotate(90)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#fff" stop-opacity="0" />
        <stop offset=".15" stop-color="#003c66" />
        <stop offset=".85" stop-color="#003c66" />
        <stop offset="1" stop-color="#fff" stop-opacity="0" />
      </linearGradient>
    </defs>
    <g>
      <path
        class="cls-1"
        d="M151.44,44.84h-65.03l-10.1,47.21h51.96l-7.13,33.85h-51.96l-19.6,91.75H7.42L51.37,11.29h111.94l-11.88,33.55Z"
      />
      <path
        class="cls-1"
        d="M305.55,150.25c-5.64,26.43-10.39,40.38-26.43,52.56-12.77,9.5-27.91,18.71-62.06,18.71-40.09,0-63.25-17.82-63.25-44.54,0-6.83.89-14.85,2.38-21.97L186.77,11.29h42.46l-28.8,135.7c-1.78,7.72-2.38,13.96-2.38,18.71,0,14.85,12.17,20.19,25.83,20.19,19,0,31.77-10.39,36.52-24.94,1.48-4.16,2.08-6.53,4.45-17.52l28.21-132.14h42.17l-29.69,138.97Z"
      />
    </g>
    <g>
      <path
        class="cls-1"
        d="M492.92,45.73h-48.7l-36.52,171.93h-42.76l36.52-171.93h-50.48l7.42-34.44h148.76l-14.25,34.44Z"
      />
      <path
        class="cls-1"
        d="M645.24,150.25c-5.64,26.43-10.39,40.38-26.43,52.56-12.77,9.5-27.91,18.71-62.06,18.71-40.09,0-63.25-17.82-63.25-44.54,0-6.83.89-14.85,2.38-21.97l30.58-143.72h42.46l-28.8,135.7c-1.78,7.72-2.38,13.96-2.38,18.71,0,14.85,12.17,20.19,25.83,20.19,19,0,31.77-10.39,36.52-24.94,1.48-4.16,2.08-6.53,4.45-17.52l28.21-132.14h42.17l-29.69,138.97Z"
      />
    </g>
    <g>
      <path
        class="cls-1"
        d="M781.92,128.58c3.56,2.38,6.83,7.13,8.91,10.39,8.61,15.44,26.72,66.51,30.88,78.69h-48.99l-10.69-33.55c-12.17-38.01-18.71-48.1-25.54-51.37-1.78-.89-3.56-1.19-5.05-1.19l-18.41,86.11h-41.87l43.95-206.37h76.91c31.18,0,49.29,17.52,49.29,45.13,0,40.68-27.91,66.81-59.39,72.16ZM770.33,44.54h-20.49l-11.88,55.82h12.77c17.82,0,25.83-1.78,32.66-7.13,8.02-6.24,13.36-19.3,13.36-28.51,0-14.25-9.21-20.19-26.43-20.19Z"
      />
      <path
        class="cls-1"
        d="M993.93,45.14h-70.08l-10.1,47.81h58.5l-7.13,33.85h-58.2l-11.58,55.23h77.8l-7.72,35.63h-120.26l43.95-206.37h117.59l-12.77,33.85Z"
      />
      <path
        class="cls-1"
        d="M1175.65,128.58c3.56,2.38,6.83,7.13,8.91,10.39,8.61,15.44,26.72,66.51,30.88,78.69h-48.99l-10.69-33.55c-12.17-38.01-18.71-48.1-25.54-51.37-1.78-.89-3.56-1.19-5.05-1.19l-18.41,86.11h-41.87l43.95-206.37h76.91c31.18,0,49.29,17.52,49.29,45.13,0,40.68-27.91,66.81-59.39,72.16ZM1164.07,44.54h-20.49l-11.88,55.82h12.77c17.82,0,25.83-1.78,32.66-7.13,8.02-6.24,13.36-19.3,13.36-28.51,0-14.25-9.21-20.19-26.43-20.19Z"
      />
    </g>
    <g>
      <path
        class="cls-1"
        d="M1345.74,217.66l-4.16-49h-60.58l-24.94,49h-44.84l111.65-206.96h44.84l21.08,206.96h-43.06ZM1335.94,91.16c-1.19-15.74-.89-31.48-.89-35.04-2.08,5.05-11.88,26.72-18.11,39.79l-18.41,38.3h40.38l-2.97-43.06Z"
      />
      <path
        class="cls-1"
        d="M1450.26,217.66h-43.06l43.95-206.37h43.06l-43.95,206.37Z"
      />
    </g>
    <path
      class="cls-1"
      d="M1604.01,217.66h-108.97l43.95-206.37h42.46l-36.52,171.93h73.94l-14.85,34.44Z"
    />
    <g>
      <path
        class="cls-3"
        d="M101.56,269.51h-53.29l-8.91,42.67h44.56l-3.03,13.46h-44.56l-10.05,47.6h57.27l-2.84,13.46H7.69l27.69-130.09h71.11l-4.93,12.9Z"
      />
      <path
        class="cls-3"
        d="M164.7,318.82l27.31,67.89h-17.83l-21.05-55.94-41.34,55.94h-18.96l54.62-69.79-22.95-60.3h17.26l16.88,47.22,34.32-47.22h18.96l-47.22,62.2Z"
      />
    </g>
    <g>
      <path
        class="cls-3"
        d="M290.05,325.45c-7.96,6.45-18.58,9.48-33.94,9.48h-22.76l-11,51.77h-15.17l27.69-130.09h33.75c29.96,0,39.63,14.41,39.63,30.15s-5.5,28.64-18.21,38.69ZM263.69,269.7h-16.5l-11.19,52.53h21.81c11,0,16.5-2.09,21.81-7.02,7.96-7.21,11.76-16.5,11.76-24.84,0-13.65-7.02-20.67-27.69-20.67Z"
      />
      <path
        class="cls-3"
        d="M399.09,269.51h-53.29l-8.91,42.67h44.56l-3.03,13.46h-44.56l-10.05,47.6h57.27l-2.84,13.46h-73.01l27.69-130.09h71.11l-4.93,12.9Z"
      />
    </g>
    <g>
      <path
        class="cls-3"
        d="M452.92,328.11h-1.9c6.07,6.07,12.33,14.41,20.1,30.15,3.6,7.21,8.72,19.34,10.81,26.17l-13.65,4.55c-3.22-7.96-6.26-14.41-10.81-24.27-6.07-13.08-11-21.43-16.31-28.82-4.74-6.64-7.77-7.59-14.22-7.78l-12.52,58.6h-15.55l27.69-130.09h28.45c28.45,0,40.77,9.48,40.77,30.34,0,24.46-19.53,41.15-42.86,41.15ZM454.43,269.7h-14.98l-10.24,48.74h13.84c11.57,0,18.77-1.33,25.03-6.64,5.88-4.93,11.19-12.9,11.19-22,0-14.22-7.4-20.1-24.84-20.1Z"
      />
      <path
        class="cls-3"
        d="M518.52,386.71h-15.17l27.69-130.09h15.17l-27.69,130.09Z"
      />
    </g>
    <g>
      <path
        class="cls-3"
        d="M646.65,269.51h-53.29l-8.91,42.67h44.56l-3.03,13.46h-44.56l-10.05,47.6h57.27l-2.84,13.46h-73.01l27.69-130.09h71.11l-4.93,12.9Z"
      />
      <path
        class="cls-3"
        d="M732.93,386.71h-16.31l-24.84-79.65c-4.74-14.98-7.96-29.77-8.15-31.1-.19.57-2.46,18.77-5.69,35.27l-15.36,75.48h-16.12l27.69-130.09h18.02l25.6,83.06c3.6,11.95,5.88,25.22,6.26,27.12.19-.95,3.03-21.05,6.83-39.44l14.41-70.73h15.36l-27.69,130.09Z"
      />
    </g>
    <g>
      <path
        class="cls-3"
        d="M859.99,275.39c-6.64-5.69-13.46-7.96-22.95-7.96-14.98,0-27.88,7.78-37.17,22.38-9.67,14.79-15.36,36.03-15.36,52.72,0,20.67,10.43,33.19,30.72,33.19,9.67,0,17.45-2.46,27.12-8.34l6.07,10.81c-11.95,6.83-25.6,10.62-38.5,10.62-25.98,0-41.53-18.58-41.53-47.03,0-21.81,7.96-47.41,23.51-64.67,12.52-14.03,30.15-22.19,46.84-22.19,12.14,0,22.57,3.98,29.96,10.81l-8.72,9.67Z"
      />
      <path
        class="cls-3"
        d="M960.3,269.51h-53.29l-8.91,42.67h44.56l-3.03,13.46h-44.56l-10.05,47.6h57.27l-2.84,13.46h-73.01l27.69-130.09h71.11l-4.93,12.9Z"
      />
    </g>
    <path
      class="cls-3"
      d="M1106.2,275.39c-6.64-5.69-13.46-7.96-22.95-7.96-14.98,0-27.88,7.78-37.17,22.38-9.67,14.79-15.36,36.03-15.36,52.72,0,20.67,10.43,33.19,30.72,33.19,9.67,0,17.45-2.46,27.12-8.34l6.07,10.81c-11.95,6.83-25.6,10.62-38.5,10.62-25.98,0-41.53-18.58-41.53-47.03,0-21.81,7.96-47.41,23.51-64.67,12.52-14.03,30.15-22.19,46.84-22.19,12.14,0,22.57,3.98,29.96,10.81l-8.72,9.67Z"
    />
    <g>
      <path
        class="cls-3"
        d="M1206.58,269.51h-53.29l-8.91,42.67h44.56l-3.03,13.46h-44.56l-10.05,47.6h57.27l-2.84,13.46h-73.01l27.69-130.09h71.11l-4.93,12.9Z"
      />
      <path
        class="cls-3"
        d="M1293.81,386.71h-16.31l-24.84-79.65c-4.74-14.98-7.96-29.77-8.15-31.1-.19.57-2.46,18.77-5.69,35.27l-15.36,75.48h-16.12l27.69-130.09h18.02l25.6,83.06c3.6,11.95,5.88,25.22,6.26,27.12.19-.95,3.03-21.05,6.83-39.44l14.41-70.73h15.36l-27.69,130.09Z"
      />
    </g>
    <g>
      <path
        class="cls-3"
        d="M1422.97,269.7h-35.27l-24.84,117.01h-14.98l24.84-117.01h-34.89l2.84-13.08h86.09l-3.79,13.08Z"
      />
      <path
        class="cls-3"
        d="M1470.75,328.11h-1.9c6.07,6.07,12.33,14.41,20.1,30.15,3.6,7.21,8.72,19.34,10.81,26.17l-13.65,4.55c-3.22-7.96-6.26-14.41-10.81-24.27-6.07-13.08-11-21.43-16.31-28.82-4.74-6.64-7.77-7.59-14.22-7.78l-12.52,58.6h-15.55l27.69-130.09h28.45c28.45,0,40.77,9.48,40.77,30.34,0,24.46-19.53,41.15-42.86,41.15ZM1472.27,269.7h-14.98l-10.24,48.74h13.84c11.57,0,18.77-1.33,25.03-6.64,5.88-4.93,11.19-12.9,11.19-22,0-14.22-7.4-20.1-24.84-20.1Z"
      />
    </g>
    <path
      class="cls-3"
      d="M1614.01,269.51h-53.29l-8.91,42.67h44.56l-3.03,13.46h-44.56l-10.05,47.6h57.27l-2.84,13.46h-73.01l27.69-130.09h71.11l-4.93,12.9Z"
    />
  </svg>
</template>

<script>
const WHITE_LOGO_ROUTES = [
  "My Future Journey",
  "Albert Street Home",
  "Boggo Road Home",
  "Exhibition Home",
  "Roma Street Home",
  "Woolloongabba Home",
  "Benefits Home",
  "Benefits Select",
  "Benefits Slides",
  "Taking Shape Home",
  "Taking Shape Stations",
  "Progress Home",
  "Progress Brisbane",
  "Progress Gold Coast",
  "New Upgraded Stations",
  "Station Progress"
];

export default {
  name: "CRRLogo",
  computed: {
    classes() {
      const classes = [];
      if (WHITE_LOGO_ROUTES.includes(this.$route.name)) classes.push("white");
      return classes;
    }
  }
};
</script>

<style lang="scss" scoped>
.cls-1 {
  fill: #003c66;
}
.cls-2 {
  fill: none;
  stroke: url(#linear-gradient-blue);
  stroke-miterlimit: 10;
  stroke-width: 1.5px;
}
.cls-3 {
  fill: #939598;
}
.white .cls-3 {
  fill: #fff;
}

.white .cls-1 {
  fill: #fff;
}
.white .cls-2 {
  stroke: url(#linear-gradient-white);
}
</style>
